import React, { useEffect, useState } from 'react'
import PublicLayout from '../../layouts/PublicLayout'
import { getProgramList, getCategoryProgram } from '../../services/program'
import { Box, Button, Container, Grid, Select, Text, TextInput } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import classes from './Training.module.css'
import SkeletonCard from '../../components/ui/SekeletonCard'
import ProgramCard from '../../components/pages/Program/ProgramCard'
import TrainingHeader from '../../components/pages/Program/TrainingHeader'
import dayjs from 'dayjs'
import { HelmetProvider } from 'react-helmet-async'
import SEOPage from '../../components/seo/SEOPage'
import { useScrollIntoView } from '@mantine/hooks'

const defaultParameter = {
  skip: 0,
  take: 8,
  search: '',
  fromDate: '',
  toDate: '',
  orderBy: 'nearest',
  order: 'asc',
  kind: 'training',
  eventCategory: null
}

const defaultOrder = [
  {
    label: 'Terdekat',
    value: 'asc'
  },
  {
    label: 'Terlama',
    value: 'desc'
  }
]

const Training = () => {
  const { scrollIntoView, targetRef } = useScrollIntoView({
    offset: 60
  })
  const [params, setParams] = useState(defaultParameter)
  const [trainingList, setTrainingList] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleGetCategoryList = async () => {
    const params = {
      kind: 'training',
    }
    try {
      const response = await getCategoryProgram(params)
      const dataCategory = response.data
      const remapCategory = dataCategory.map((val) => {
        return {
          value: val.id,
          label: val.name
        }
      })
      setCategoryList(remapCategory)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetTrainingList = async () => {
    setLoading(true)
    try {
      const response = await getProgramList(params)
      setTrainingList(response.data)
      setCount(response.count)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetCategoryList()
  }, [])

  useEffect(() => {
    handleGetTrainingList()
    // eslint-disable-next-line
  }, [params])

  const handleSearchChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value })
  }

  const handleChangeOrder = (e) => {
    setParams({ ...params, 'order': e })
  }

  const handleChangeCategory = (e) => {
    setParams({ ...params, 'eventCategory': e })
  }

  const handleChangeDate = (e) => {
    if (e[1] !== null) {
      setParams({ ...params, 'fromDate': dayjs(e[0]).format('YYYY-MM-DD'), 'toDate': dayjs(e[1]).format('YYYY-MM-DD') })
    } else {
      setParams({ ...params, 'fromDate': '', 'toDate': '' })
    }
  }

  const handlePage = (params) => {
    if (trainingList.length < count) {
      setParams({ ...params, 'take': params.take + 8 })
    }
  }

  const loadingData = (number) => Array.from({ length: number }, (_, i) => {
    return (
      <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={i}>
        <SkeletonCard />
      </Grid.Col>
    )
  })

  const mappingDataTraining = (data) => {
    if (data.length > 0) {
      const remap = data.map((val, index) => {
        return (
          <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={index}>
            <ProgramCard data={val} />
          </Grid.Col>
        )
      })
      return remap
    } else {
      return (
        <Grid.Col span={12}>
          <Box ta='center' py={60}>
            <Text c="dark">Training yang anda cari belum tersedia</Text>
          </Box>
        </Grid.Col>
      )
    }
  }

  return (
    <HelmetProvider>
      <SEOPage title='Training - Laju Reaksi by Katalis Talenta Indonesia' />
      <PublicLayout>
        <TrainingHeader handleScroll={() => scrollIntoView({alignment: 'center'})} />
        <Box className={classes.trainingSection}>
          <Container fluid className={classes.section}>
            <Box>
              <Box className={classes.paddingPage}>
                <Text className={classes.titleHeader} fw="bold">Temukan Pelatihan yang ingin kamu hadiri!</Text>
                <Text className={classes.captionHeader}>Program pelatihan dan webinar dari PT Katalis Talenta Indonesia</Text>
                <Box className={classes.searchTrainingBox}>
                  <Grid>
                    <Grid.Col span={{ base: 12, md: 3,lg: 3 }}>
                      <TextInput
                        placeholder="Cari Training. . ."
                        name="search"
                        onChange={handleSearchChange}
                      />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 3,lg: 3 }}>
                      <Select
                        name="eventCategory"
                        data={categoryList}
                        onChange={handleChangeCategory}
                        value={params.eventCategory}
                        placeholder='Pilih Kategori'
                        clearable
                      />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 3,lg: 3 }}>
                      <Select
                        name="order"
                        data={defaultOrder}
                        onChange={handleChangeOrder}
                        allowDeselect={false}
                        value={params.order}
                      />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 3,lg: 3 }}>
                      <DatePickerInput
                        clearable
                        valueFormat="DD-MM-YYYY"
                        type="range"
                        placeholder="Pilih Tanggal Training"
                        onChange={handleChangeDate}
                        miw={220}
                      />
                    </Grid.Col>
                  </Grid>
                </Box>
              </Box>
              <Box pos='absolute' ref={targetRef} style={{ height: '45vh' }} />
              <Box mt="xl">
                <Grid gutter='xl' className={classes.gridProgramCard} align="center">
                  {loading ? loadingData(8) : mappingDataTraining(trainingList)}
                </Grid>
              </Box>
              <Box mt={30} align="center">
                {trainingList.length < count ? (<Button loading={loading} color='red' onClick={() => handlePage(params)}>Selengkapnya</Button>) : ''}
              </Box>
            </Box>
          </Container>
        </Box>
      </PublicLayout>
    </HelmetProvider>
  )
}

export default Training